import {useEffect, useState} from 'react';
import {Routes} from 'constants/index';
import {hasWindow} from 'utils/functions';
import {useQueryValues} from 'utils/queryObj';

type UseResult = {
	show: boolean
	hide: () => void
	appt?: string
}
const confirmString = 'success';

export const createSuccessLink = () => {
	if (!hasWindow()) {
		return '';
	}

	return Routes.bookingSuccess;
};

export const useSuccess = (): UseResult => {
	const [show, setShow] = useState<boolean>(false);
	const {read, update} = useQueryValues('sc');
	const {conf, appt} = read({conf: '', appt: ''});

	// Toggle show state to match desired state
	useEffect(() => {
		const desired = Boolean(conf === confirmString && appt);
		if(desired !== show) {
			setShow(!show);
		}
	}, [conf, appt, show]);

	return {
		show,
		hide: () => {
			update({});
			setShow(false);
		},
		appt,
	};
};
